import { BasicRequest } from "./basicRequest";

export class ExecuteMoovStepInstanceRequest extends BasicRequest{
    public moovStepInstanceId!:number;

    constructor(){
        super();
    }
}